(function() {
  'use strict';
  
  class ShopifyWishlist {
    constructor() {
      this.storageKey = 'shopify_wishlist';
      this.items = this.loadWishlist();
      this.init();
     
    }

    init() {
      this.updateHeaderCount();
      this.attachEventListeners();
      this.observeHeaderChanges(); 
      
      if (document.getElementById('wishlist-items-container')) {
        this.renderWishlistPage();
      }
      
      this.updateAllWishlistButtons();
    }

    loadWishlist() {
      try {
        const data = localStorage.getItem(this.storageKey);
        return data ? JSON.parse(data) : [];
      } catch (e) {
        console.error('Error loading wishlist:', e);
        return [];
      }
    }

    saveWishlist() {
      try {
        localStorage.setItem(this.storageKey, JSON.stringify(this.items));
        this.updateHeaderCount();
      } catch (e) {
        console.error('Error saving wishlist:', e);
      }
    }

    toggleItem(productData) {
      const index = this.items.findIndex(item => item.id === productData.id);
      
      if (index > -1) {
        this.items.splice(index, 1);
        this.showNotification('Removed from wishlist', false);
      } else {
        this.items.push({
          id: productData.id,
          title: productData.title,
          price: productData.price,
          image: productData.image,
          url: productData.url,
          variants: productData.variants || []
        });
        this.showNotification('Added to wishlist', true);
      }
      
      this.saveWishlist();
      this.updateAllWishlistButtons();
      
      if (document.getElementById('wishlist-items-container')) {
        this.renderWishlistPage();
      }
    }

    isInWishlist(productId) {
      return this.items.some(item => item.id === productId);
    }

    // ✅ FIXED: Now uses CSS class instead of inline display style
    updateHeaderCount() {
      const countElements = document.querySelectorAll('.wishlist-count');
      const count = this.items.length;
      
      countElements.forEach(el => {
        el.textContent = count;
        el.classList.toggle('has-items', count > 0);
      });
    }

    // ✅ NEW: MutationObserver to re-sync count if theme re-renders header
    observeHeaderChanges() {
      const self = this;
      const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.type === 'childList') {
            const affected = [...mutation.addedNodes].some(node =>
              node.nodeType === 1 && (
                node.classList?.contains('wishlist-count') ||
                node.querySelector?.('.wishlist-count')
              )
            );
            if (affected) {
              self.updateHeaderCount();
            }
          }

         
          if (
            mutation.type === 'attributes' &&
            mutation.target.classList?.contains('wishlist-count')
          ) {
            self.updateHeaderCount();
          }
        });
      });

      const header = document.querySelector('header') || document.body;
      observer.observe(header, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style', 'class']
      });
    }

    updateAllWishlistButtons() {
      const buttons = document.querySelectorAll('.wishlist-toggle-btn');
      
      buttons.forEach(btn => {
        const productId = btn.getAttribute('data-product-id');
        const isInList = this.isInWishlist(productId);
        const icon = btn.querySelector('.wishlist-icon');
        
        if (icon) {
          icon.style.fill = isInList ? 'currentColor' : 'none';
        }
        
        btn.classList.toggle('in-wishlist', isInList);
      });
    }

    attachEventListeners() {
      document.addEventListener('click', (e) => {
        const btn = e.target.closest('.wishlist-toggle-btn');
        if (!btn) return;
        
        e.preventDefault();
        e.stopPropagation();
        
        const productData = {
          id: btn.getAttribute('data-product-id'),
          title: btn.getAttribute('data-product-title'),
          price: btn.getAttribute('data-product-price'),
          image: btn.getAttribute('data-product-image'),
          url: btn.getAttribute('data-product-url'),
          variants: this.getProductVariants(btn)
        };
        
        this.toggleItem(productData);
      });

      const clearBtn = document.getElementById('clear-all-wishlist');
      if (clearBtn) {
        clearBtn.addEventListener('click', () => {
          if (confirm('Are you sure you want to clear all items from your wishlist?')) {
            this.clearWishlist();
          }
        });
      }
    }

    getProductVariants(btn) {
      try {
        const variantsData = btn.getAttribute('data-product-variants');
        return variantsData ? JSON.parse(variantsData) : [];
      } catch (e) {
        return [];
      }
    }

    renderWishlistPage() {
      const container = document.getElementById('wishlist-items-container');
      const emptyState = document.getElementById('wishlist-empty-state');
      const clearSection = document.getElementById('wishlist-clear-section');
      
      if (!container) return;
      
      if (this.items.length === 0) {
        container.innerHTML = '';
        if (emptyState) emptyState.style.display = 'block';
        if (clearSection) clearSection.style.display = 'none';
        this.updateHeaderCount();
        return;
      }
      
      if (emptyState) emptyState.style.display = 'none';
      if (clearSection) clearSection.style.display = 'block';
      
      container.innerHTML = this.items.map(item => this.createProductCard(item)).join('');
      
      this.updateHeaderCount();
    }

    createProductCard(item) {
      const hasVariants = item.variants && item.variants.length > 1;
      
      return `
        <div class="wishlist-card" data-product-id="${item.id}">
          <div class="wishlist-card-image">
            <div class="wishlist-wrp">
              <img src="${item.image}" alt="${item.title}" loading="lazy">
            </div>
            <button class="wishlist-heart wishlist-toggle-btn" 
                    data-product-id="${item.id}"
                    data-product-title="${item.title}"
                    data-product-price="${item.price}"
                    data-product-image="${item.image}"
                    data-product-url="${item.url}"
                    title="Remove from wishlist"
                    type="button">
              <svg class="wishlist-icon" width="20" height="20" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="1">
                <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
              </svg>
            </button>
          </div>
          <div class="wishlist-card-info">
            <div class="wishlist-card-wrp">
              <a href="${item.url}" class="wishlist-card-title">${item.title}</a>
              <div class="wishlist-price-wrap">
                <span class="wishlist-price">${item.price}</span>
              </div>
            </div>
            ${hasVariants ? this.createVariantDropdown(item) : ''}
            <a href="${item.url}" class="add-to-cart-btn">View Product</a>
          </div>
        </div>
      `;
    }

    createVariantDropdown(item) {
      if (!item.variants || item.variants.length <= 1) return '';
      
      const options = item.variants.map(variant => 
        `<option value="${variant.id}">${variant.title} - ${variant.price}</option>`
      ).join('');
      
      return `<select class="variant-select">${options}</select>`;
    }

    clearWishlist() {
      this.items = [];
      this.saveWishlist();
      this.updateAllWishlistButtons();
      
      if (document.getElementById('wishlist-items-container')) {
        this.renderWishlistPage();
      }
      
      this.showNotification('Wishlist cleared', false);
    }

    showNotification(message, isAdded) {
      let container = document.getElementById('wishlist-notification-container');
      if (!container) {
        container = document.createElement('div');
        container.id = 'wishlist-notification-container';
        container.style.cssText = 'position: fixed; top: 20px; right: 20px; z-index: 10000;';
        document.body.appendChild(container);
      }
      
      const notification = document.createElement('div');
      notification.className = 'wishlist-notification';
      notification.style.cssText = `
        background: ${isAdded ? '#111' : '#666'};
        color: white;
        padding: 12px 20px;
        border-radius: 5px;
        margin-bottom: 10px;
        box-shadow: 0 2px 10px rgba(0,0,0,0.2);
        animation: slideIn 0.3s ease;
        font-size: 14px;
      `;
      notification.textContent = message;
      
      container.appendChild(notification);
      
      setTimeout(() => {
        notification.style.animation = 'slideOut 0.3s ease';
        setTimeout(() => notification.remove(), 300);
      }, 2000);
    }
  }

  // ✅ UPDATED: CSS now fully controls .wishlist-count visibility via .has-items class
  const style = document.createElement('style');
  style.textContent = `
    @keyframes slideIn {
      from { transform: translateX(100%); opacity: 0; }
      to { transform: translateX(0); opacity: 1; }
    }
    @keyframes slideOut {
      from { transform: translateX(0); opacity: 1; }
      to { transform: translateX(100%); opacity: 0; }
    }
    .wishlist-toggle-btn.in-wishlist .wishlist-icon {
      fill: #000 !important;
    }

    
    .wishlist-count {
      display: none !important;
       position: absolute;
    top: 0;
    right: 0;
    background: #D0473E;
    color: #fff;
    border-radius: 50%;
    width: 18px;
    height: 18px;
    align-items: center;
    justify-content: center;
    font-size: 11px;
    font-weight: bold;
    }
    .wishlist-count.has-items {
      display: flex !important;
    }
  `;
  document.head.appendChild(style);

  // Initialize
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      window.shopifyWishlistInstance = new ShopifyWishlist();
    });
  } else {
    window.shopifyWishlistInstance = new ShopifyWishlist();
  }

  window.addEventListener('load', function() {
    if (window.shopifyWishlistInstance) {
      window.shopifyWishlistInstance.updateHeaderCount();
    }
  });

})();
